import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import BackArrow from '@jwp/ott-theme/assets/icons/arrow_backward.svg?react';
import PlayerFlag from '@jwp/ott-theme/assets/icons/player_Flag.svg?react';
import PlayerThumbsUp from '@jwp/ott-theme/assets/icons/player_Thumbsup.svg?react';
import PlayerThumbsUpFilled from '@jwp/ott-theme/assets/icons/player_Thumbsup_filled.svg?react';
import PlayerThumbsDown from '@jwp/ott-theme/assets/icons/player_Thumbsdown.svg?react';
import PlayerShare from '@jwp/ott-theme/assets/icons/player_Share.svg?react';
import type { PlaylistItem } from '@jwp/ott-common/types/playlist';

import CollapsibleText from '../CollapsibleText/CollapsibleText';

import styles from './CustomPlayerHeader.module.scss';

type Props = {
  item: PlaylistItem;
  title: string;
  description?: string;
  likeCount?: number;
  isLiked?: boolean;
  showReport?: boolean;
  showLike?: boolean;
  showDislike?: boolean;
  showShare?: boolean;
  onBack?: () => void;
  onReport?: () => void;
  onLike?: () => void;
  onDislike?: () => void;
  onShare?: () => void;
  onMoreClick?: () => void;
};

const CustomPlayerHeader: React.FC<Props> = ({
  item,
  title,
  description,
  likeCount = 0,
  isLiked = false,
  showReport = true,
  showLike = true,
  showDislike = true,
  showShare = true,
  onBack,
  onReport,
  onLike,
  onDislike,
  onShare,
  onMoreClick,
}) => {
  const { t } = useTranslation('player');
  const normalizedTitle = title.trim().toLowerCase();
  const normalizedDescription = description?.trim().toLowerCase();
  const shouldShowDescription =
    description &&
    normalizedDescription &&
    normalizedDescription !== normalizedTitle &&
    !normalizedDescription.startsWith(normalizedTitle);

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <div className={styles.titleRow}>
          <button type="button" className={styles.backButton} onClick={onBack} aria-label={t('back')}>
            <BackArrow />
          </button>
          <h1 className={styles.title}>{title}</h1>
        </div>
        {shouldShowDescription && (
          <CollapsibleText
            item={item}
            text={description}
            className={styles.description}
            maxLines={2}
            showMoreClickHandler={onMoreClick}
          />
        )}
      </div>

      {/* <div className={styles.right}>
        {showReport && (
          <button type="button" className={styles.reportButton} onClick={onReport} aria-label={t('report')}>
            <PlayerFlag />
          </button>
        )}

        {(showLike || showDislike || showShare) && (
          <div className={styles.actionsPill}>
            {showLike && (
              <button
                type="button"
                className={classNames(styles.actionButton, { [styles.liked]: isLiked })}
                onClick={onLike}
                aria-label={t('like')}
                aria-pressed={isLiked}
              >
                {isLiked ? <PlayerThumbsUpFilled /> : <PlayerThumbsUp />}
                <span className={styles.likeCount}>{likeCount}</span>
              </button>
            )}
            {showLike && showDislike && <div className={styles.divider} />}
            {showDislike && (
              <button type="button" className={styles.actionButton} onClick={onDislike} aria-label={t('dislike')}>
                <PlayerThumbsDown />
                <span>{t('dislike')}</span>
              </button>
            )}
            {(showLike || showDislike) && showShare && <div className={styles.divider} />}
            {showShare && (
              <button type="button" className={styles.actionButton} onClick={onShare} aria-label={t('share')}>
                <PlayerShare />
                <span>{t('share')}</span>
              </button>
            )}
          </div>
        )}
      </div> */}
    </header>
  );
};

export default CustomPlayerHeader;
